const DEVICE_TYPE_NAMES = {
  ALS: 'ALS',
  BLS: 'BLS',
  HELI: 'Heli',
};

export default DEVICE_TYPE_NAMES;
